export default __webpack_public_path__ + "static/media/icon.marker (1).bf50bbaa.svg";